import {ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {VRGroupService} from '../../vrgroup.service';
import {JourneySection, RunningTrain} from '../../common/train';
import {BaseComponent} from '../../../../components/general/base/base.component';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'qm-vrgroup-train-compositions',
  templateUrl: './train-compositions.component.html',
  styleUrls: ['./train-compositions.component.scss']
})
export class TrainCompositionsComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  public train: RunningTrain;
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<void> = new Subject();
  public compositions: JourneySection[] = [];
  public compositionStrings: string[] = [];

  constructor(private vrGroupService: VRGroupService, private changeDetector: ChangeDetectorRef) {
    super();
    this.name = 'TrainCompositionsComponent';
  }

  ngOnInit() {
    this.vrGroupService.trainComposition$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      // console.log('Composition data received', data);
      if (this.train && data && data._id === this.train._id) {
        if (data.compositions) {
          this.compositions = data.compositions;
        } else {
          this.compositions = [];
        }
        this.compositionStrings = this.compositions.map(comp => this.vrGroupService.compositionStringFromJourneySection(comp));
        this.changeDetector.markForCheck();
      }
    });
    this.vrGroupService.makeCompositionRequest(this.train._id, this.train.station);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.vrGroupService.makeCompositionRequest(this.train._id, this.train.station);
  }

  /**
   * Angular destructor hook
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
